export default "__VITE_ASSET__ZGa$8bTo__"